function notEmpty<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

function reduceBy<T, K extends keyof T, R>(
  list: T[],
  by: K,
  cb: (acc: R, val: T[K], item: T, i: number) => R,
  defaultRtn: R,
) {
  return list.reduce((acc, item, i) => {
    const val = item[by];
    return cb(acc, val, item, i);
  }, defaultRtn);
}

function createMapBy<T, K extends keyof T>(list: T[], by: K) {
  return reduceBy(
    list,
    by,
    (map, val, item) => {
      const group = map.get(val) || [];
      group.push(item);
      map.set(val, group);
      return map;
    },
    new Map<T[K], T[]>(),
  );
}

function createUniqueMapBy<T, K extends keyof T>(list: T[], by: K) {
  return reduceBy(
    list,
    by,
    (map, val, item) => {
      map.set(val, item);
      return map;
    },
    new Map<T[K], T>(),
  );
}

function arrayRemove<T, K extends keyof T>(list: T[], by: K, value: T[K]) {
  const index = list.findIndex(item => item[by] === value);
  if (index > -1) {
    list.splice(index, 1);
  }
}

export { createMapBy, createUniqueMapBy, arrayRemove, notEmpty };



// WEBPACK FOOTER //
// ./src/utils/collections.ts